import React from "react";

const ROTATE_CSS = {
    0: 'rotate-0',
    90: 'rotate-90',
    180: 'rotate-180',
    270: 'rotate-270',
}

const renderThumbnail = ({original, rotate}) => {
    return (
        <div
            style={{
                overflow: 'hidden',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <img className={ROTATE_CSS[rotate]} src={original} alt=""/>
        </div>
    )
}

export default renderThumbnail;



// WEBPACK FOOTER //
// ./src/modules/customer/component/task-widget/customerPreCheckinImageWidget/renderer/renderThumbnail.js